import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ClientsService } from 'src/app/services/customers/clients.service';


declare var L:any;

@Component({
    selector: 'app-map',
    templateUrl: './map.component.html',
    styleUrls: ['./map.component.scss'],
    standalone: false
})
export class MapComponent implements OnInit, AfterViewInit {

  map:any; markers: any;

  constructor(private _client: ClientsService) { }

  ngOnInit(): void {

  }

  ngAfterViewInit(){
    this.markers = L.markerClusterGroup({ chunkedLoading: true });
    this.map = L.map('map').setView([28.3185375, -81.3950552], 7);

    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(this.map);

    fetch("https://raw.githubusercontent.com/danielcs88/fl_geo_json/master/geojson-fl-counties-fips.json")
    .then((response) =>{
        return response.json()
    })
    .then((data) => {
        console.log(data);
        L.geoJson(data, {style: style}).addTo(this.map);
    })
    .catch((error) => {
        console.log(`This is the error: ${error}`)
    })


    var style = ((feature:any)=> {
        return {
            fillColor: getColor(feature.properties.Pop_Density),
            weight: 2,
            opacity: 1,
            color: 'gray',
            fillOpacity: 0.5
        }
    })


    function getColor(d) {
        if (d > 1400) {
            return '#8c2d04';
        } else if (d > 700) {
            return '#cc4c02';
        } else if (d > 400) {
            return '#ec7014';
        } else if (d > 100) {
            return '#fe9929';
        } else if (d > 50) {
            return '#fec44f';
        } else if (d > 25) {
            return '#fee391';
        } else {
            return '#ffffd4';
        }
    }


    this.loadCustomers();


  }


  loadCustomers(){
    this._client.getAll().subscribe(async (data:any) => {
      for(let client of data.clients){
       if(client.geoid){
          let marketo = L.marker([client.geoid.latitude, client.geoid.longitude]);
          let dataPop = `<strong class="py-2">ID</strong> : ${client.ident_GUI} <br /><strong class="py-2">NAME CLIENT</strong> <br />${client.name_client} <br /> <strong class="py-2">ADDRESS</strong> <br />${client.address}`;

          marketo.bindPopup(dataPop).openPopup();
          await this.markers.addLayer(marketo);
       }
      }

      this.map.addLayer(this.markers)

    })
    
  }

}
